module.exports = __webpack_public_path__ + "static/media/ATMA-SPHERE MA-3 TUBE AMPLIFIER.26857b4d.png";